<div class="card">
    <div class="card-header">
        <h2 class="card-title">CPI Policy Information <span class="badge badge-success">{{status}}</span></h2>
        <div class="actions">
            @if (policyInEffect) {
            <button class="btn btn-warning btn-sm" data-toggle="modal" data-target="#deactivateCpiPolicyModal">Cancel Policy</button>
            }
            <button class="btn btn-success btn-sm" (click)="save()" [disabled]="information.invalid" id="btn-save-cpi">Save</button>
        </div>
    </div>
    <div class="card-body">
        <div class="row">
            <form class="col-xs-12 col-xl-8" [formGroup]="information">
                <div class="form-row">
                    <div class="form-group col-md-6 col-xs-12">
                        <contact-advanced-search type="cpiVendor" id="cpiVendor-input" [contactIdSaved]="information.get('contactId').value || 0" [contactNameSaved]="information.get('companyName').value || null" (setContactId)="setContactIdEvent($event)" [isDisabled]="status == 'active'"></contact-advanced-search>
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="effectiveDate">Effective Date</label>
                        <input class="form-control form-control-sm" type="date" id="effectiveDate" formControlName="effectiveDate" autocomplete="off" />
                        @if (information.controls['effectiveDate'].invalid) {
                        }
                    </div>
                    <div class="form-group col-md-3 col-xs-12">
                        <label for="policyNumber">Policy Number</label>
                        <input class="form-control form-control-sm" type="text" id="policyNumber" formControlName="policyNumber" autocomplete="off" />
                        @if (information.controls['policyNumber'].invalid) {
                        }
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-lg-4 col-xs-12">
                        <label for="paymentCycle">Payment Cycle</label>
                        <select id="paymentCycle" formControlName="paymentCycle" class="form-control form-control-sm">
                            @for (paymentCycle of paymentCycles; track paymentCycle) {
                            <option [value]="paymentCycle">{{paymentCycle}}</option>
                            }
                        </select>
                    </div>
                    <div class="form-group col-lg-3 col-xs-12">
                        <label for="months">Term in Months</label>
                        <count-input [control]="information.get('months')"></count-input>
                    </div>
                    <div class="form-group col-lg-5 col-xs-12">
                        <label for="firstScheduledPmtDue">1st Payment Due</label>
                        <input class="form-control form-control-sm" type="date" id="firstScheduledPmtDue" formControlName="firstScheduledPmtDue" autocomplete="off" />
                        @if (information.controls['firstScheduledPmtDue'].invalid) {
                        }
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 col-xs-12">
                        <label for="defaultDeductibleAmount">Deductible Amount</label>
                        <currency-input [control]="information.get('defaultDeductibleAmount')"></currency-input>
                    </div>   
                    <div class="form-group col-md-6 col-xs-12">
                        <label for="monthlyPremium">Monthly Premium</label>
                        <currency-input [control]="information.get('monthlyPremium')"></currency-input>
                    </div>
                </div>
                <div class="form-row">
                    <div class="form-group col-md-6 col-xs-12">
                        <label for="saleLoanBalance">Amount Premium Based On</label>
                        <input type="text" class="form-control form-control-sm text-right" id="saleLoanBalance" formControlName="saleLoanBalance" />
                    </div>
                    <div class="form-group col-md-6 col-xs-12">
                        <label for="premiumPerPayment">Scheduled Payment Amount</label>
                        <input type="text" class="form-control form-control-sm text-right" id="premiumPerPayment" formControlName="premiumPerPayment" />
                    </div>
                    @if (information.get('endDate').value) {
                    <div class="form-group col-md-6 col-xs-12">
                        <label for="endDate">Ending Date</label>
                        <input type="date" class="form-control form-control-sm" id="endDate" formControlName="endDate">
                    </div>
                    }
                </div>
            </form>
            <section class="col-xs-12 col-xl-4">
                <h4>Payments</h4>
                <ul class="list-group list-group-flush">
                @for (payment of payments; track payment.id) {
                    <li class="list-group-item">
                        <p><span class="material-icons">attach_money</span></p>
                        <p [class]="dueToClass(payment.due)">{{payment.due | date:'E MMM dd, yy'}}</p>
                        <p>{{payment.amount | currency}}</p>
                        <p>{{payment.status | lowercase}}</p>
                    </li>
                }
                @empty {
                    <li class="list-group-item empty">No payments found.</li>
                }

                @if (records > 0) {
                    <li class="list-group-item empty"><p class="text-muted text-right">{{page * 7}} / {{records}} displayed</p></li>
                }
                </ul>
            </section>
        </div>
    </div>
</div>

<!-- warning modal -->
<div class="modal fade" id="deactivateCpiPolicyModal" data-backdrop="static" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="dripicons-cross text-danger display-1"></span>
                <h4 class="text-danger w-100 text-center">Cancel</h4>
                <span class="text-dark my-1 text-center">Are you sure you want to cancel this policy?</span>
                <button class="btn btn-danger mt-2" (click)="deactivate()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    Yes</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-cancel">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->